import React, { useState } from 'react'
import SearchColor from '@/assets/icons_new/SearchColor.svg'
import SearchInput from '@/modules/drivers/shared/SearchInput'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

type Props = {
  search: string
  setSearch: (value: string) => void
  searchResults: number
  placeholder?: string
}

export function SearchPopover({
  search,
  setSearch,
  searchResults,
  placeholder,
}: Props) {
  const [showSearch, setShowSearch] = useState(false)
  const { t } = useLocalize()

  const hasSearch = !!search && search.trim() !== ''

  const handleClear = (e: React.MouseEvent) => {
    e.stopPropagation()
    setSearch('')
    setShowSearch(false)
  }

  return (
    <div className="tw-relative">
      {hasSearch && (
        <div
          className="tw-flex tw-cursor-pointer tw-items-center tw-gap-2 tw-rounded-lg tw-border-2 tw-border-primary tw-px-2 tw-py-1"
          onClick={() => setShowSearch(true)}
        >
          <img src={SearchColor} alt="Search Icon" />

          <span className="tw-text-sm tw-font-medium tw-text-primary">
            {search}
          </span>

          <button
            type="button"
            className="tw-ml-1 tw-font-bold tw-text-primary"
            onClick={handleClear}
          >
            ×
          </button>
        </div>
      )}

      {!hasSearch && (
        <div
          className="tw-flex tw-cursor-pointer tw-items-center tw-gap-2 tw-border-2 tw-border-transparent tw-px-1"
          onClick={() => setShowSearch(true)}
        >
          <img src={SearchColor} alt="Search Icon" />
          <p className="tw-text-sm tw-font-medium tw-text-primary">
            {t('common.search')}
          </p>
        </div>
      )}

      {showSearch && (
        <SearchInput
          search={search}
          searchResults={searchResults}
          setSearch={setSearch}
          placeholder={placeholder}
          handleClickOutside={() => setShowSearch(false)}
        />
      )}
    </div>
  )
}
